import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import Toast from "../../components/Toast";
import { saveCustomer } from "../../actions/CustomerActions";
import { styleSelect } from "../../constants/customStyles";
import Select from 'react-select';
import { getVehicleReplacementById, saveFromDriver, updateByAdmin, updateVehicleReplacement } from "../../actions/VehicleReplacementsActions";
import Dropzone, { useDropzone } from 'react-dropzone';
import SignatureCanvas from 'react-signature-canvas'
import { Swiper, SwiperSlide } from "swiper/react";
import { Grid, Scrollbar } from "swiper";
import Mobilemenu from "../../layouts/mobile-menu";

function DriverTracking() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();

    useEffect(() => {
            dispatch(getVehicleReplacementById(params.id))
         }, []);

    const vehicleReplacement = useSelector(state => state?.vehicleReplacements?.vehicleReplacement);
    const loading = useSelector(state => state?.loading?.loading);

    const [data, setData] = useState('');

    useEffect(() => {
        if (Object.keys(vehicleReplacement).length > 0) {
            let preloadImages = [];
            vehicleReplacement.images.forEach(function (image, index) {
                preloadImages.push({ preview: image.image_path + '/' + image.filename, default: 0, id: image.vehicle_replacement_image_id, status: image.status });
            })
            setFiles(preloadImages);
            // setPreviewImages(preloadImages);
        }
    }, [vehicleReplacement])

    useEffect(() => {
        setData(vehicleReplacement?.replace_vehicle_status)
    }, [vehicleReplacement])

    const handleChangeKmIn = (event) => {
        setVehicleInfo({
            ...vehicleInfo,
            [event.target.name]: event.target.value,
        });
    };
    const handleChangeKmOut = (event) => {
        setVehicleInfo({
            ...vehicleInfo,
            [event.target.name]: event.target.value,
        });
    };

    const handleChangeFuelInOption = (e) => {
        // e)
        setVehicleInfo({
            ...vehicleInfo,
            fuel_in: e.value,
            fuel_id: e.label,
        });
    };
    const handleChangeFuelOutOption = (e) => {
        // e)
        setVehicleInfo({
            ...vehicleInfo,
            fuel_out: e.value,
            fuel_out_id: e.label,
        });
    };

    const FuelOptions = [
        { label: 'F', value: 'F' },
        { label: '1/3', value: '1/3' },
        { label: '1/2', value: '1/2' },
        { label: '3/4', value: '3/4' },
        { label: 'E', value: 'E' },
    ]
    const [files, setFiles] = useState([]);

    const thumbsContainer = {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: 16
    };

    const thumb = {
        display: 'inline-flex',
        borderRadius: 2,
        border: '1px solid #eaeaea',
        marginBottom: 8,
        marginRight: 15,
        width: 100,
        height: 100,
        padding: 4,
        boxSizing: 'border-box'
    };

    const thumbInner = {
        display: 'block',
        minWidth: 92,
        overflow: 'hidden'
    };

    const img = {
        display: 'block',
        width: 'auto',
        height: '100%'
    };

    const { getRootProps, getInputProps } = useDropzone({
        accept: '.jpeg,.png,.jpg',
        maxFiles: 30,
        maxSize: 5000000,
        onDropAccepted: acceptedFiles => {
            if (files.length < 1) {
                setFiles(files.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    default: (index == 0) ? 1 : 0
                }))));
            } else {
                if (acceptedFiles.length + files.length > 30) {
                    Toast.fire({
                        icon: 'error',
                        title: 'Maximum 30 Images Allowed',
                    });
                } else {
                    setFiles(files.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                        preview: URL.createObjectURL(file),
                        default: 0
                    }))));
                }
            }
        },
        onDropRejected: rejectedFiles => {
            if (rejectedFiles.length > 0) {
                let error = 'There was an error';
                if (rejectedFiles[0].errors[0].code == 'file-invalid-type') {
                    error = 'File Format Not Supported';
                } else if (rejectedFiles[0].errors[0].code == 'file-too-large') {
                    error = 'Image Size greater than 5mb'
                } else if (rejectedFiles[0].errors[0].code == 'too-many-files') {
                    error = 'Maximum 30 Images Allowed';
                }
                // setDropzoneError(rejectedFiles[0].errors[0].message);
                Toast.fire({
                    icon: 'error',
                    title: error,
                });
            }
        }
    });

    const removeImage = (file, index) => {
        setFiles(prevFiles => {
            const updatedFiles = prevFiles.filter((_, i) => i !== index);
    
            if (index === 0 && file.default === 1 && updatedFiles.length > 0) {
                updatedFiles[0].default = 1;
            } else if (index !== 0 && file.default === 1) {
                updatedFiles[0].default = 1;
            }
    
            const removedImageId = file.id || null;
    
            if (removedImageId) {
                setVehicleInfo({
                    ...vehicleInfo,
                    imageId: [removedImageId]
                });
            }
    
            return updatedFiles;
        });
    };    

    const [dropzoneTitle, setDropZoneTitle] = useState("Please Upload Photos");
    // const thumbs = files.map((file, index) => {
    //     return (
    //         <React.Fragment key={index + 1}>
    //             <SwiperSlide>
    //                 <div>
    //                     <div style={thumb} className={`${file.default == 1 ? "default-image" : ''}`} key={file.name}>
    //                         <div style={thumbInner}>
    //                             <img
    //                                 src={file.preview}
    //                                 style={img}
    //                             />
    //                         </div>
    //                     </div>
    //                     <span class="image-close" onClick={() => removeImage(file, index)}>&times;</span>
    //                 </div>
    //             </SwiperSlide>
    //         </React.Fragment>
    //     )
    // }
    // );
    // 'thumbs', thumbs)
    const [vehicleInfo, setVehicleInfo] = useState(null);
    const [activeAccordionItem, setActiveAccordionItem] = useState(null);
    const signatureRef = useRef(null);
    const signatureRefOut = useRef(null);
    const [canvasData, setCanvasData] = useState({});

    const handleAccordionClick = (index, detail) => {
        setActiveAccordionItem(index == activeAccordionItem ? null : index);
        if (detail?.km_in && detail?.km_in) {
            setVehicleInfo({
                km_in: detail?.km_in,
                fuel_in: detail?.fuel_in,
                remarks: detail?.remarks,
                vehicle_status: detail?.replace_vehicle_status_id,
            });
            if (detail?.remarks) {
                // Update the canvasData state with the canvas data for this accordion item
                setCanvasData({
                    ...canvasData,
                    [detail.id]: detail.remarks,
                });
            }
        } else if (detail?.km_out && detail?.km_out) {
            setVehicleInfo({
                km_out: detail?.km_out,
                fuel_out: detail?.fuel_out,
                remarks: detail?.remarks,
                vehicle_status: detail?.replace_vehicle_status_id,
            });
            if (detail?.remarks) {
                // Update the canvasData state with the canvas data for this accordion item
                setCanvasData({
                    ...canvasData,
                    [detail.id]: detail.remarks,
                });
            }
        } else {
            Toast.fire({
                icon: 'error',
                title: 'No Data Found!'
            })
        }
    };

    const update = (id) => {
        if (vehicleInfo?.km_in && vehicleInfo?.km_in == null) {
            Toast.fire({
                icon: 'error',
                title: 'Km In is Required!'
            })
        } else if (vehicleInfo?.fuel_in && vehicleInfo?.fuel_in == null) {
            Toast.fire({
                icon: 'error',
                title: 'Fuel In is Required!'
            })
        } else if (vehicleInfo?.km_out && vehicleInfo?.km_out == null) {
            Toast.fire({
                icon: 'error',
                title: 'Km Out is Required!'
            })
        } else if (vehicleInfo?.fuel_out && vehicleInfo?.fuel_out == null) {
            Toast.fire({
                icon: 'error',
                title: 'Fuel Out is Required!'
            })
        } else {
            let data = {
                vehicleInfo: vehicleInfo,
            }
            let formData1 = new FormData();
            formData1.append('data', JSON.stringify(data));
            for (var key in files) {
                formData1.append('images[]', files[key])
            }
            dispatch(updateByAdmin(formData1, id))
        }
    }


    return (
        <React.Fragment>
             <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <div className="intro-y d-flex align-items-center my-2 mt-5">
                        <h2 className="fs-base ms-3 fw-medium me-auto">
                            Customer Info
                        </h2>
                    </div>
                    <div className="grid columns-12 gap-6 mt-3">
                        <div className="intro-y g-col-12">
                            {/* <!-- BEGIN: Form Layout --> */}
                            <div className="intro-y box p-5">
                                <div className="grid columns-12">
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="name" className="form-label">Customer Name :</label>
                                        <input id="name" name="name" disabled value={vehicleReplacement?.customer?.name} type="text" className="form-control" placeholder="Enter Customer Name" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="mobile" className="form-label">Customer Mobile Number :</label>
                                        <input id="mobile" name="mobile" disabled value={vehicleReplacement?.customer?.mobile} type="text" className="form-control" placeholder="Enter Customer Mobile Number" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid columns-12 mt-3">
                        <div className="intro-y g-col-12 g-col-sm-6">
                            <div className="intro-y d-flex align-items-center my-2 mb-3">
                                <h2 className="fs-base ms-3 fw-medium me-auto">
                                    Customer Vehicle
                                </h2>
                            </div>
                            <div className="intro-y box p-5">
                                <div className="grid columns-12">
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="chasisNo" className="form-label">Chasis No. :</label>
                                        <input disabled id="chasisNo" name="chasisNo" type="text" value={vehicleReplacement?.vehicle?.chasis_no} className="form-control" placeholder="Enter Chasis No." />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="plateNo" className="form-label">Plate No. :</label>
                                        <input disabled id="plateNo" name="plateNo" type="text" value={vehicleReplacement?.vehicle?.plate_number} className="form-control" placeholder="Enter Plate No." />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="intro-y g-col-12 g-col-sm-6">
                            <div className="intro-y g-col-12 g-col-sm-6">
                                <div className="intro-y d-flex align-items-center my-2 mb-3">
                                    <h2 className="fs-base ms-3 fw-medium me-auto">
                                        Replaced Vehicle
                                    </h2>
                                </div>
                                <div className="intro-y box p-5">
                                    <div className="grid columns-12">
                                        <div className="intro-y g-col-12 g-col-sm-6">
                                            <label for="chasisNo" className="form-label">Chasis No. :</label>
                                            <input disabled id="chasisNo" name="chasisNo" type="text" value={vehicleReplacement?.replaceable_vehicle?.chasis_no} className="form-control" placeholder="Enter Chasis No." />
                                        </div>
                                        <div className="intro-y g-col-12 g-col-sm-6">
                                            <label for="plateNo" className="form-label">Plate No. :</label>
                                            <input disabled id="plateNo" name="plateNo" type="text" value={vehicleReplacement?.replaceable_vehicle?.plate_number} className="form-control" placeholder="Enter Plate No." />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="faq-accordion-2" class="accordion accordion-boxed mt-3">
                        {
                            data && data.length > 0 ?
                                data.filter(detail => ![6, 7, 8, 9, 10].includes(detail.replace_vehicle_status_id))
                                    .sort((a, b) => a.id - b.id)
                                    .map((detail, index) => (
                                        <div key={index} className="accordion-item box">
                                            <div className="accordion-header" onClick={() => handleAccordionClick(index, detail)}>
                                                <button className={`accordion-button fs-lg ${index == activeAccordionItem ? '' : 'collapsed'}`} type="button">
                                                    {index + 1 + ') ' + detail?.replace_vehicle_status_master?.name}
                                                </button>
                                            </div>
                                            <div className={`accordion-collapse collapse ${index == activeAccordionItem ? 'show' : ''}`}>
                                                <div class="accordion-body lh-lg">
                                                    {
                                                        detail && detail?.km_in && detail?.fuel_in ?
                                                            <span>
                                                                <div className="grid columns-12">
                                                                    <div className="intro-y g-col-12 g-col-md-6">
                                                                        <label for="km_in" className="form-label">Km In <span className="text-theme-6">*</span> :</label>
                                                                        <input id="km_in" name="km_in" value={vehicleInfo?.km_in} onChange={handleChangeKmIn} type="text" className="form-control" placeholder="Km Out" />
                                                                        <label for="crud-form-1" className="form-label mt-3">Fuel In <span className="text-theme-6">*</span> :</label>
                                                                        <Select styles={styleSelect} value={{ label: vehicleInfo?.fuel_in, value: vehicleInfo?.fuel_in }} options={FuelOptions} name="fuel_in" onChange={(e) => handleChangeFuelInOption(e)} />
                                                                        {canvasData[detail.id] && (
                                                                            <span>
                                                                                <label for="signature" className="form-label mt-3">Customer Signature <span className="text-theme-6">*</span> :</label>
                                                                                <div className="border border-gray-300 rounded-2 p-5">
                                                                                    <img src={canvasData[detail.id]} alt="Canvas" />
                                                                                    {/* You can also add other details related to the canvas */}
                                                                                </div>
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <div className="intro-y g-col-12 g-col-sm-6">
                                                                        <label for="image" className="form-label">Image:</label>
                                                                        <section className="text-center form-control w-full">
                                                                            <aside style={thumbsContainer} className="justify-content-center mb-0">
                                                                                {
                                                                                    (files.length == 0) &&
                                                                                    <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                                                                }
                                                                            </aside>
                                                                            <Swiper
                                                                                slidesPerView={5}
                                                                                scrollbar={{
                                                                                    hide: true,
                                                                                }}
                                                                                grid={{
                                                                                    rows: 1,
                                                                                }}
                                                                                modules={[Grid, Scrollbar]}
                                                                                className="mySwiper h-full"
                                                                            >
                                                                                {
                                                                                    files
                                                                                        .filter(file => file?.status == vehicleInfo?.vehicle_status)
                                                                                        .map((file, index) => {
                                                                                            return (
                                                                                                <React.Fragment key={index + 1}>
                                                                                                    <SwiperSlide>
                                                                                                        <div>
                                                                                                            <div style={thumb} className={`${file.default == 1 ? "default-image" : ''}`} key={file.name}>
                                                                                                                <div style={thumbInner}>
                                                                                                                    <img src={file.preview} style={img} />
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <span class="image-close" onClick={() => removeImage(file, index)}>&times;</span>
                                                                                                        </div>
                                                                                                    </SwiperSlide>
                                                                                                </React.Fragment>
                                                                                            );
                                                                                        })
                                                                                }
                                                                            </Swiper>
                                                                            <div {...getRootProps({ className: 'dropzone p-2' })}>
                                                                                <input {...getInputProps()} />
                                                                                <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                                                                <div className="btn btn-primary w-25 mt-3">Upload Photos</div>
                                                                            </div>
                                                                        </section>
                                                                    </div>
                                                                </div>
                                                            </span>
                                                            :
                                                            <span>
                                                                <div className="grid columns-12">
                                                                    <div className="intro-y g-col-12 g-col-md-6">
                                                                        <label for="km_out" className="form-label">Km Out <span className="text-theme-6">*</span> :</label>
                                                                        <input id="km_out" name="km_out" value={vehicleInfo?.km_out} onChange={handleChangeKmOut} type="text" className="form-control" placeholder="Km Out" />
                                                                        <label for="crud-form-1" className="form-label mt-3">Fuel Out <span className="text-theme-6">*</span> :</label>
                                                                        <Select styles={styleSelect} value={{ label: vehicleInfo?.fuel_out, value: vehicleInfo?.fuel_out }} options={FuelOptions} id="repalcedVehicleFuelId" name="replacedVehicleFuelOut" onChange={(e) => handleChangeFuelOutOption(e)} />
                                                                        {canvasData[detail.id] && (
                                                                            <span>
                                                                                <label for="signature" className="form-label mt-3">Customer Signature <span className="text-theme-6">*</span> :</label>
                                                                                <div className="border border-gray-300 rounded-2 p-5">
                                                                                    <img src={canvasData[detail.id]} alt="Canvas" />
                                                                                    {/* You can also add other details related to the canvas */}
                                                                                </div>
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <div className="intro-y g-col-12 g-col-sm-6">
                                                                        <label for="image" className="form-label">Image:</label>
                                                                        <section className="text-center form-control w-full">
                                                                            <aside style={thumbsContainer} className="justify-content-center mb-0">
                                                                                {
                                                                                    (files.length == 0) &&
                                                                                    <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                                                                }
                                                                            </aside>
                                                                            <Swiper
                                                                                slidesPerView={5}
                                                                                scrollbar={{
                                                                                    hide: true,
                                                                                }}
                                                                                grid={{
                                                                                    rows: 1,
                                                                                }}
                                                                                modules={[Grid, Scrollbar]}
                                                                                className="mySwiper h-full"
                                                                            >
                                                                                {
                                                                                    files
                                                                                        .filter(file => file?.status == vehicleInfo?.vehicle_status)
                                                                                        .map((file, index) => {
                                                                                            return (
                                                                                                <React.Fragment key={index + 1}>
                                                                                                    <SwiperSlide>
                                                                                                        <div>
                                                                                                            <div style={thumb} className={`${file.default == 1 ? "default-image" : ''}`} key={file.name}>
                                                                                                                <div style={thumbInner}>
                                                                                                                    <img src={file.preview} style={img} />
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <span class="image-close" onClick={() => removeImage(file, index)}>&times;</span>
                                                                                                        </div>
                                                                                                    </SwiperSlide>
                                                                                                </React.Fragment>
                                                                                            );
                                                                                        })
                                                                                }
                                                                            </Swiper>
                                                                            <div {...getRootProps({ className: 'dropzone p-2' })}>
                                                                                <input {...getInputProps()} />
                                                                                <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                                                                <div className="btn btn-primary w-25 mt-3">Upload Photos</div>
                                                                            </div>
                                                                        </section>
                                                                    </div>
                                                                </div>
                                                            </span>
                                                    }
                                                    <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end mt-5">
                                                        <button onClick={() => update(detail?.id)} disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Update</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                : ''
                        }
                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}

export default DriverTracking;